/**
 *  课程小结 api 枚举
 */
export enum EnumApiSummary {
  /** 学习小结基础数据 */
  BasicData = '/course/api/course/summary/basic',
  /** 作业数据 */
  HomeWorks = '/homework/api/homeworks/myself',
  /** 互动数据 */
  ActionData = '/moment/api/moments/summary',
  /** 日记数据 */
  Dairys = '/moment/api/moments/summary/diary',
  /** 学习轨迹数据 */
  Record = '/moment/api/moments/summary/cards'
}
